import { useQuery } from 'react-query';
import { useMemo } from 'react';

export default () => {
  const { data, ...query } = useQuery(['GET', '/apis/v2/online_intake/healthcare_services', {}], {
    cacheTime: 1000 * 60 * 5,
  });
  const presentingIssues = data?.data;
  const presentingIssuesOptions = useMemo(() => (presentingIssues || []).map((item) => ({ value: item.id, label: item.attributes.name })), [presentingIssues]);

  return { data: presentingIssuesOptions, ...query };
};
